import { useState, useEffect } from "react";
import { getMechanicWalletTransactions } from "../../../services/mechanicWallet";
import Loading from "../../UI/Loading/Loading";
import EmptyContent from "../../UI/EmptyContent/EmptyContent";
import WalletBanner from "./WalletBanner/WalletBanner";
import WalletTransactions from "./WalletTransactions/WalletTransactions";
import classes from "./Wallet.module.css";

const Wallet = () => {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState();
  const [isTransactionsLoading, setIsTransactionsLoading] = useState(true);
  const [transactionsError, setTransactionsError] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setIsTransactionsLoading(true);
        setTransactionsError("");
        const response = await getMechanicWalletTransactions();
        const {
          data: { transactions, balance },
        } = response;
        setBalance(balance);
        setTransactions(transactions);
      } catch (err) {
        setTransactionsError("حدث خطأ أثناء تحميل معاملاتك السابقة");
      } finally {
        setIsTransactionsLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div className={classes["wallet"]}>
      <WalletBanner balance={balance} />
      {isTransactionsLoading ? (
        <Loading className={classes["wallet__loading"]} />
      ) : transactionsError || transactions.length === 0 ? (
        <EmptyContent
          className={classes["wallet__empty"]}
          message="لا يوجد معاملات سابقه لعرضها !"
          withAction
        />
      ) : (
        <WalletTransactions transactions={transactions} />
      )}
    </div>
  );
};

export default Wallet;
